import React, { useEffect, useState } from "react";

import CreatableSelect from "react-select/creatable";

const Creatables = ({ options, value, onChange, defaultValue }) => {
  const style = {};
  const [roles, setRoles] = useState([]);
  const [roleValue, setRoleValue] = useState([]);
  return (
    <CreatableSelect
      isClearable
      isMulti
      onChange={onChange}
      options={options}
      styles={style}
      value={value}
      // defaultValue={defaultValue}
    />
  );
};

export default Creatables;
